<template>
  <div class="card h-full mb-2" :class="[directionReverse ? reverseDirection : '', cardClass]">
    <div class="card-header p-3 pt-2">
      <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute"
        :class="`bg-gradient-${icon.background} shadow-${icon.background}`">
        <i class="material-icons opacity-10" :class="icon.color" aria-hidden="true">{{ icon.name }}</i>
      </div>
      <div class="pt-1" :class="stIsRTL ? 'text-start' : 'text-end'">
        <p class="text-xs mb-0">{{ title.text }}</p>
        <h4 class="mb-0">{{ title.value }}</h4>
      </div>
    </div>
    <hr class="dark horizontal my-0" />
    <div class="card-footer p-3" :class="stIsRTL ? 'text-start' : 'text-end'">
      <!--  eslint-disable-next-line vue/no-v-html -->
      <p class="text-xs mb-0" v-html="detail"></p>
    </div>

    <MaterialButton v-if="showButton" variant="outline" class="btn btn-sm py-2 w-50 mx-auto" @click.stop="handleButtonClick">
      View Details
  </MaterialButton>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MaterialButton from "@/components/common/MaterialButton.vue";
export default {
  name: "MiniStatisticsCard",
  components: {
    MaterialButton,
  },
  data() {
    return {
      reverseDirection: "flex-row-reverse justify-content-between",
    };
  },
  props: {
    title: {
      type: Object,
      required: true,
      text: String,
      value: [Number, String],
    },
    detail: {
      type: String,
      default: "",
    },
    icon: {
      type: Object,
      required: true,
      name: String,
      color: String,
      background: String,
      default: () => ({
        color: "text-white",
        background: "success",
      }),
    },
    directionReverse: {
      type: Boolean,
      default: false,
    },
    card: {
      type: Object,
      default: null,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    cardClass: {
      type: String,
      default: "",
    },
  },
  emits: ['openModal'],
  computed: {
    // ...mapState(["isRTL"]),
    ...mapGetters(["stIsRTL"]),

  },
  methods: {
    handleButtonClick() {
      if (this.card) {
        this.$emit('openModal', this.card);
      }
    }
  }
};
</script>

<style scoped>
.h-full {
  height: 100%;
}

.card {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.card-header {
  flex-shrink: 0;
}

.card-footer {
  flex-shrink: 0;
}
</style>